export default () => {
    const collapseHeadings = Array.prototype.slice.call(
        document.querySelectorAll('[data-toggle="collapse__body"]')
    );

    document.addEventListener(
        "click",
        (e) => {
            if (collapseHeadings.indexOf(e.target) > -1) {
                const collapseBody = e.target.getAttribute("data-target");
                e.target.classList.toggle("active");
                collapse(collapseBody, "toggle");
            }
        },
        false
    );

    const collapse = (selector, cmd) => {
        const targets = Array.prototype.slice.call(
            document.querySelectorAll(selector)
        );
        targets.forEach((target) => {
            target.classList.toggle("show");
        });
    };

};
